/**
 * View
 */
import Config from '../Config';
import Util from '../Util';
import Loading from '../Loading';
import ViewMenu from './ViewMenu';
import Vote from './Vote';
import Scrap from './Scrap';
import ParamInfo from './ParamInfo';
import Report from './Report';
import Delete from './Delete';
import Update from './Update';
import Viewer from './Viewer';
import Share from './Share';
import ViewCharacterInfo from './ViewCharacterInfo';
import GoToTop from '../GoToTop';
import SandboxLike from './sandbox/SandboxLike';
import ArticleNavigation from './ArticleNavigation';
import Plugin from './plugin/Plugin';
import Speech from './playground/Speech';
import CommentAnchor from './comment/CommentAnchor';
import StorageComment from './StorageComment';
import Svg from '../Svg';
import Tag from './Tag';

// import PrevNextArticle from './PrevNextArticle';

class View {

	public onLoaded: any;

	public onSignLoaded: any;

	protected _id: string;

	protected paramInfo: ParamInfo;

	private $node: any;

  	private articleId: string;

  	private categoryId: string;

  	private tagCategoryId: string;

	private tagArticleId: number;

	private isNotice: boolean;

	private guid: string;

	private loading: Loading;

	private bodyElement: string;

	private voteButton: string;

	private moreButton: string;

	private commentCount: string;

	private sandBoxButton: string;

	private firstBr: string;

	private viewImages: string;

	private viewSignatureCls: string;

	private viewSignature: string;

	private gameUserUid: string;

	private gameServerId: string;

	private gameCharacterId: string;

	private gameCharacterName: string;

	private uid: string;

	private scrap: Scrap;

	private delete: Delete;

	private update: Update;

	private viewer: Viewer;

	private share: Share;

	private viewMenu: ViewMenu;

	private report: Report;

	private commentAnchor: CommentAnchor;

  	private isAdminUser: boolean;

	private tag: any;

	private tags: any;

	constructor( node: any, options: any ) {
		const param = Util.getParams();

		this.$node = node;

		this.$node.addClass( Config.COMMUNITY_NODE );

		this._id = this.$node.attr( 'id' );

		this.isAdminUser = null;

		jQuery.extend( true, Config, options );

		// @TODO test speech
		if ( Util.net( '' ) === 'opdev' ) {
			Config.isSpeech = true;
		}

		if ( options.viewAPIUrl ) {
			if (typeof(options.viewAPIUrl) !== "function") {
				Config.view = () => {
					return options.viewAPIUrl;
				}
			} else {
				Config.view = options.viewAPIUrl;
			}
		}

		// Config.view = ( options.viewAPIUrl ) ? options.viewAPIUrl : Config.view;

		// this.articleId = Config.__secretArticleId || parseInt( param.articleId, 10 );

		this.articleId = Config.__secretArticleId || param.articleId;

		this.isNotice = ( param.isNotice === '1' ) ? true : false;

		this.guid = '';

		this.loading = new Loading( this.$node );
		this.loading.setUI();
		this.loading.show();

		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();

		this.commentAnchor = new CommentAnchor();

		this.addSelector();
		this.addEvent();
		this.addObserver();
	}

	public getData( _template: any ) {
		const _data: any = {};
		const _categoryId = this.paramInfo.getParamByKey( 'categoryId' ) || '0';
		const viewUrl = Util.Tmpl.render({
			data: {
				articleId: this.articleId,
				board: Config.board,
				categoryId: _categoryId,
			},
			template: ( !this.isNotice ) ? Config.view : Config.noticeView,
		});

		if ( this.isNotice && _categoryId ) {
			_data.categoryId = _categoryId;
		}

		const viewPromise = Util.get( viewUrl, 'get', _data );
		const get$ = Util.from( viewPromise );
		get$.subscribe( ( data: any ) => {

			// data = Util.convertCamelCase( data );
			this.loaded( data, _template );

		}, ( data: any ) => {
			if ( data.status === 400 ) {
				// location.href = Config.listPage;
			}

			if ( data.status === 401 ) {
				// Config.apiError( data );
			}

			this.loaded( 'error', '' );

			this.loading.hide();
		});
	}

	protected addEvent() {

	}

	private addObserver() {
		this.onLoaded = new Util.Observer();
		this.onLoaded.add( () => {
			if ( Config.isShowPrevNextNavigation ) {
				const articleNavigation = new ArticleNavigation( this.$node );
				articleNavigation.get( this.articleId, Config.prevNextNavigationSize, this.categoryId );
			}

			if ( Config.isVote ) {
				const votePlugin = new Plugin( 'View', 'Vote', Config.board );
				votePlugin.addPlugin();
			}

			if ( Config.isTag ) {
				this.tag = new Tag();
				this.tag.getAttachedTag(this.tags);
			}

			// @TODO tmp speech API
			if ( Config.isSpeech ) {
				const speech = new Speech();
			}

			this.commentAnchor.goToComment( 'onViewLoaded' );

			jQuery('body').on('click', '.view-body a[href="NOT_ALLOWED_URL"]',(e) => {
			  e.preventDefault();
			  return false;
			});
		});

		this.onSignLoaded = new Util.Observer();
		this.onSignLoaded.add( () => {
			this.commentAnchor.goToComment( 'onSignLoaded' );
		});
	}

	private addSelector() {
		this.bodyElement = `body`;
		this.voteButton = `#${this._id} .co-btn-like`;
		this.moreButton = `#${this._id} .ncCommunityMoreButton`;
		this.commentCount = `#ncCommunityComment .commentTotalCount`;
		this.sandBoxButton = `.view-utils`;
		this.firstBr = `.view-body > [ data-contents-type=text ]:eq( 0 ):has( br )`;
		this.viewImages = `.view-body [ data-contents-type=image ]`;
		this.viewSignatureCls = `.view-signature`;
		this.viewSignature = `#${this._id} ${this.viewSignatureCls}`;
	}

	private hideSignature( tmp?: any ) {
		( tmp ) ?
			jQuery( tmp ).find( this.viewSignatureCls ).hide() :
			jQuery( this.viewSignature ).hide();
	}

	private showSignature() {
		jQuery( this.viewSignature ).show();
		this.onSignLoaded.emit();
	}

	private loaded( data: any, _template: any ) {
        Svg.get();

		Config.viewData = data;

		if ( data === 'error' || !data.article ) {
			this.loading.hide();
			this.onLoaded.emit();

			return;
		}

		// 이전 다음 아티클 데이터
		Config.prevNextData = data.prevNextArticleEntries || '';

		const _article = (Config.isUuid) ? data.article.article.contentMeta : data.article;
		const _writer = _article.writer;
		const _category = (Config.isUuid) ? _article.categoryBoard : _article.category;

		// set boardAlias for Top notice comment
		Config.viewBoardAlias = (Config.isUuid) ? _article.categoryBoard.boardAlias : _article.boardAlias;
		Config.viewBoardObserver.emit( Config.viewBoardAlias );

		this.guid = _writer.loginUser.uid;
		this.gameUserUid = _writer.gameUser.gameUserUid;
		this.gameServerId = _writer.gameUser.gameServerId;
		this.gameCharacterId = _writer.gameUser.gameCharacterId;
		this.gameCharacterName = _writer.gameUser.gameCharacterName;
		this.uid = _writer.loginUser.uid;
		this.isAdminUser = _writer.admin || _writer.adminUser;
		this.categoryId = (Config.isUuid) ? _category.id : _category.categoryId;
		this.tagCategoryId = (Config.isUuid) ? _category.snow.boardId : _category.categoryId;
		this.tagArticleId = (Config.isUuid) ? _article.snow.contentId : _article.articleId;

		const tmp = _template.view( data, this.isNotice );
		this.$node.append( tmp );
		this.hideSignature();

		// 메뉴
		this.viewMenu = new ViewMenu( this.$node, this.isNotice );

		this.tags = data.tags;

		// 추천
		if ( !Config.isSandboxLike ) {
			const vote = new Vote( Config.guid, data );
		} else {
			jQuery( this.voteButton ).hide();
			const sandboxLike = new SandboxLike( jQuery( this.sandBoxButton ), Config.board, this.articleId );
		}

		// 스크랩
		this.scrap = new Scrap( this._id );

		// 삭제
		this.delete = new Delete( this.guid, this._id, this.gameCharacterName, this.gameServerId );

		// 수정
		this.update = new Update( this.guid, this._id, this.gameCharacterName, this.gameServerId, this.categoryId );

		// 신고
		this.report = new Report( jQuery( this.bodyElement ),
			data.article.writer.gameUser.gameCharacterName || data.article.writer.loginUser.name, this._id );

		// 뷰어
		this.viewer = new Viewer();

		// 공유하기
		this.share = new Share();

		// 시그니처 리셋
		if ( Config.isGameSignature && this.gameServerId ) {
			// let _viewCharacterInfo = new ViewCharacterInfo( this.$node, this.gameUserUid, this.gameServerId, this.uid, Config.guid, this.gameCharacterId );
			const _viewCharacterInfo: ViewCharacterInfo = new ViewCharacterInfo( this.$node, data.article.writer.gameUser,  data.article.writer.loginUser );
			_viewCharacterInfo.onLoaded.add( () => {
				this.showSignature();
			});
			_viewCharacterInfo.onFailed.add( () => {
				this.showSignature();
			});
		} else {
			this.showSignature();
		}

		this.loading.hide();

		this.setCommentCount(data);

		this.hideMoreButton();

		this.removeFirstBr();

		if( !this.isAdminUser && Config.isViewImageMaxWidth ) {
			this.setImageMaxWidth();
		}

		// @desc show the Top button
		GoToTop.show();

		StorageComment.set(data.article);

		Util.setCookie('board_categoryId', this.categoryId);
		Util.setCookie('tag_categoryId', this.tagCategoryId);
		Util.setCookie('tag_articleId', this.tagArticleId);
		/* deplicated */
		Util.setCookie('_categoryId', this.tagCategoryId);
		Util.setCookie('_tagArticleId', this.tagArticleId);

		this.onLoaded.emit();
	}

	// @deprecated
	private hideMoreButton() {
		const $moreButton = jQuery( this.moreButton );
		if ( $moreButton.find( 'ul' ).has( 'li' ).length === 0 ) {
			$moreButton.hide();
		}
	}

	// @deprecated
	private setArticleNavigation() {
		const articleNavigation = new ArticleNavigation( this.$node );
		articleNavigation.get( this.articleId, 10 );
	}

	private setCommentCount( data: any ) {
		jQuery( this.commentCount ).text( data.article.commentCount );
	}

	private removeFirstBr() {
		const selector = jQuery( this.firstBr );

		if ( selector.text() === '' ) {
			selector.height( 0 );
		}
	}

	private setImageMaxWidth() {
		const $selector = jQuery( this.viewImages );
		if ( !!$selector ) {
			$selector.each((index, element) => {
				const _data = jQuery(element).data('contents-json');
				if( !!_data && _data.width < _data.height ) {
					jQuery(element).addClass('is-portrait');
				}
			});
		}
	}

}

export default View;
